import { useGetSearchParam } from '@/hooks/useGetSearchParams'
import { useParams, useLocation } from 'react-router'
import { useIsPageBuilder } from './useIsPageBuilder'
import {
  catalogReturnPathToPageId,
  isMdTextViewerRoute,
  type MdTextViewerLocationState,
} from '@/catalog-apps/components/component-library/MdTextComponent/mdTextViewerNavigation'

const pageBuilderPageId = 'page-builder-page'
const pageBuilderAppKey = 'page-builder-app-key'
const pageBuilderProjectId = -1
const pageBuilderWorkspaceId = -1
const pageBuilderAppId = -1
const pageBuilderOrganisationId = -1

const PB_CONTEXT = {
  pageId: pageBuilderPageId,
  appKey: pageBuilderAppKey,
  page: pageBuilderPageId,
  splat: undefined,
  appId: pageBuilderAppId,
  projectId: pageBuilderProjectId,
  workspaceId: pageBuilderWorkspaceId,
  organisationId: pageBuilderOrganisationId,
  pageFilterStorageKey: `page-filter-selections/${pageBuilderAppKey}?projectId=${pageBuilderProjectId}&workspaceId=${pageBuilderWorkspaceId}`,
}

export function useAppContext() {
  const { pathname, state } = useLocation()
  const isPageBuilder = useIsPageBuilder()
  const { appKey, page, '*': splat } = useParams()
  const appId = useGetSearchParam<number>('appId')
  const projectId = useGetSearchParam<number>('projectId')
  const workspaceId = useGetSearchParam<number>('workspaceId')
  const organisationId = useGetSearchParam<number>('organisationId')

  const pageFilterStorageKey = `/page-filter-selections/${appKey}?projectId=${projectId}&workspaceId=${workspaceId}`

  if (isPageBuilder || (pathname.includes('/applications/') && !pathname.includes('/apps/'))) {
    return {
      ...PB_CONTEXT,
    }
  }

  if (appKey && isMdTextViewerRoute(pathname, appKey)) {
    const viewerState = (state ?? {}) as MdTextViewerLocationState
    const pageIdFromReturn = viewerState.from ? catalogReturnPathToPageId(viewerState.from, appKey) : undefined
    const viewerPrefix = `/apps/${appKey}/md-text-viewer/`
    const mdTextSplat = pathname.startsWith(viewerPrefix)
      ? pathname.slice(viewerPrefix.length).split('?')[0]
      : splat
    return {
      pageId: pageIdFromReturn ?? `/${appKey}/home`,
      appKey,
      page: undefined,
      splat: mdTextSplat,
      appId,
      projectId,
      pageFilterStorageKey,
      workspaceId,
      organisationId,
    }
  }

  const pageId =
    appKey && page ? `/${appKey}/${page}${splat ? `/${splat}` : ''}` : appKey ? `/${appKey}/home` : undefined

  return { pageId, appKey, page, splat, appId, projectId, pageFilterStorageKey, workspaceId, organisationId }
}
